/**
 * Plan-Display-Helper (TQ #5466).
 *
 * Konvention (Patric-Entscheidung 2026-05-21): VOLL anzeigen, kein Strip.
 * Format: `<item_name> (<variant_name>)` falls beide vorhanden, sonst
 * `<item_name>`, sonst Fallback `<plan_name>` oder `<plan_id>`.
 *
 * Beispiele:
 *   item_name="IT-SCE Workspace Mail", variant_name="Mit Aria"
 *     => "IT-SCE Workspace Mail (Mit Aria)"
 *   item_name="IT-SCE Workspace Dateispeicher", variant_name="Standard 50 GB"
 *     => "IT-SCE Workspace Dateispeicher (Standard 50 GB)"
 *   item_name="IT-SCE Workspace BASE", variant_name="Standard"
 *     => "IT-SCE Workspace BASE (Standard)"
 *
 * Source-of-Truth: ERPNext Item.item_name + Item.variant_name, durchgereicht
 * via subscription_plans -> portal-api OrgServiceItem. Keine String-Magie /
 * Regex / Strip.
 *
 * Verwendung:
 *   import { formatPlanDisplay } from '../services/planDisplay'
 *   <div>{formatPlanDisplay(service)}</div>
 */

export interface PlanDisplayFields {
  item_name?: string | null
  variant_name?: string | null
  plan_name?: string | null
  plan_id?: string
}

export function formatPlanDisplay(p: PlanDisplayFields): string {
  const itemName = p.item_name?.trim()
  const variantName = p.variant_name?.trim()

  if (itemName && variantName) {
    return `${itemName} (${variantName})`
  }
  if (itemName) {
    return itemName
  }
  return p.plan_name?.trim() || p.plan_id || ''
}
